import { fileViewerAtom, previewKeyAtom } from 'js/file_viewer/core/atoms/atom';
export const textEncodingAtom = previewKeyAtom(undefined);
export const areLineNumbersHiddenAtom = fileViewerAtom(false);
//# sourceMappingURL=text.preenvesnextjs.map
